import { copy } from "./shared";
import ThankYouBody from "./ThankYouBody";
import "../templates/Template1.css";
import "./CheckoutTemplate1.css";

/*
   Checkout Template 1 — a seamless continuation of sales Template 1.
   Reuses Template1.css directly (same .clp1-root design system): the real
   .site-nav, the dark .hero band with its grid mesh + .hero-title/.accent,
   the .btn-hero-primary button and .site-footer. Only the form + order
   summary cards are checkout-specific (CheckoutTemplate1.css), styled to
   match the template's enroll-card look.
*/
export default function ThankYouTemplate1({ data = {} }) {
  const c = copy(data);

  return (
    <div className="clp1-root">
      {/* NAV — same as the sales page */}
      <nav className="site-nav">
        <div className="container">
          <div className="d-flex align-items-center justify-content-between">
            <span className="brand">
              {c.logo ? <img src={c.logo} className="site-logo" alt="" /> : <span className="cok1-brandtext">{c.brand}</span>}
            </span>
            <span className="cok1-secure">✓ Order confirmed</span>
          </div>
        </div>
      </nav>

      {/* HERO — reuses the sales hero band + accent-word title */}
      <section className="hero cok1-hero">
        <div className="container">
          <div className="hero-content cok1-hero-content">
            <span className="cok1-eyebrow">Thank you</span>
            <h1 className="hero-title">
              You're <span className="accent">enrolled</span>
            </h1>
            {c.sub ? <p className="hero-subtitle">{c.sub}</p> : null}
          </div>
        </div>
      </section>

      {/* FORM + ORDER SUMMARY — in the template's card style */}
      <div className="container">
        <ThankYouBody data={data} p="cok1" c={c} />
      </div>

      {/* FOOTER — same as the sales page */}
      <footer className="site-footer">
        <div className="container">
          <div className="cok1-foot">{c.guaranteeOn ? c.guarantee : `© ${c.brand}`}</div>
        </div>
      </footer>
    </div>
  );
}
